export default {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('source/pages/legal/PrivacyPolicyPage.vue'),
    props: true,
    meta: {
        title: 'Privacy Policy - HQZen',
        loginRequired: false,
    },
};
